import React from "react";
import Box from "@mui/material/Box";
import myMedicationsLogo from "../../../assets/images/logos/my-medications-logo.png";

const MyMedicationsDashboardLogo = ({ height, maxWidth, sx }) => (
  <Box
    component="img"
    src={myMedicationsLogo}
    alt="My Medications"
    sx={{
      display: "block",
      height: height ?? "auto",
      width: "auto",
      maxWidth: maxWidth ?? "100%",
      ...sx,
    }}
  />
);

export default MyMedicationsDashboardLogo;
